// extracted by mini-css-extract-plugin
module.exports = {"mobile":"999","desktop":"1000"};